import instance from './axiosInstance';

export const getDecodedStacktrace = <T>(reqBody) =>
  instance.post<T>('/appData/stacktrace/decode', reqBody);
